// "Om projektet": DRAFT written by Claude from the project's blog (owner decision Q2: Claude drafts,
// the owner edits). Facts only from the blog; no costs, no technical detail beyond the essentials.
// Paragraphs are wrapped to the 40-column screen by program.ts.

export const ABOUT_DRAFT = true;

export const ABOUT: string[] = [
  "Julkalenderspel är ett bevarandeprojekt. Målet är att SVT:s gamla julkalenderspel ska gå att spela igen, utan Flash.",
  "Varje spel byggs om från originalets egna filer. Bilder, ljud och filmer sparas byte för byte, så att originalet alltid finns kvar.",
  "Spelen har två lägen. Vanilla är spelet som det var. Master är en nyversion med uppskalade bilder och filmer, gjord för dagens skärmar.",
  "Måttstocken är en USB-sticka: någon ska kunna starta spelen om 20 år, i webbläsaren eller som eget program på datorn.",
  // No game titles here: this text ships in the page's code, so it would announce a game before
  // its door opens. The games are named only by the server-filtered calendar.
  "En ny lucka öppnas varje dag, 1-24 december.",
];
